/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

/**
 * Číselník plánů přehrávání.
 * @enum {'DYNAMIC' | 'RANDOM' | 'STATIC'}
 * @readonly
 */
const ScheduleEnum = {
  /** Playlist bude přehrán dle pořadí stop. V každém opakování se přehraje jen vybraný počet stop. */
  DYNAMIC: literal('DYNAMIC'),
  /** Playlist bude přehrán dle náhodného pořadí stop. Pořadí se při opakování nemění. */
  RANDOM: literal('RANDOM'),
  /** Playlist bude přehrán dle pořadí stop. */
  STATIC: literal('STATIC')
};

export default ScheduleEnum;
